import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import BcReactComponent from '@bibliocommons/base-bc-react-component';
import MessagingActions from '../actions/MessagingActions';
import { getRenewFailures } from '../selectors/CheckoutSelector';
import RenewFailureOverlay from '../components/borrowing/checkouts/RenewFailureOverlay';

export class RenewFailureOverlayContainer extends BcReactComponent {
  render() {
    return (
      <RenewFailureOverlay {...this.props} />
    );
  }
}

const mapStateToProps = (state) => ({
  failures: getRenewFailures(state)
});

RenewFailureOverlayContainer.propTypes = {
  messagingActions: PropTypes.objectOf(PropTypes.func),
  open: PropTypes.bool,
  handleClose: PropTypes.func
};

const mapDispatchToProps = dispatch => ({
  messagingActions: bindActionCreators(MessagingActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(RenewFailureOverlayContainer);



// WEBPACK FOOTER //
// ./app/containers/RenewFailureOverlayContainer.jsx